// Function to get speaker details by their IDs
// Takes an array of speaker IDs and a list of all speakers
export const getSpeakersByIds = (speakerIds, speakers) => {
  // Map through each speaker ID and find the corresponding speaker object from the speakers array
  return speakerIds.map(id => speakers.find(speaker => speaker.id === id));
};

// Function to get all sessions for a specific speaker
// Takes a speaker ID and the entire schedule of sessions
export const getSpeakerSessions = (speakerId, schedule) => {
  // Filter the schedule to find sessions where the speaker ID is included in the 'speakerIds' array
  return schedule.filter(session => session.speakerIds.includes(speakerId));
};
